<template>
  <div class="Map-restaurant-list">
    <div class="Map-restaurant-list__container" id="Map-restaurant-list__container">
      <ux-atoms-typo as="h1" class="Map-restaurant-list__title" color="dark" v-if="label" variant="expressive-heading-05">
        {{ label }}
      </ux-atoms-typo>
      <ul class="Map-restaurant-list__content">
        <li
          :class="[
            { 'Map-restaurant-list__item-container': cluster.length > 1 },
            { 'Map-restaurant-list__item-container--active': cluster.find((restaurant) => restaurant.id === currentRestaurantId) }
          ]"
          :id="`Map-restaurant-list__item-container-${index}`"
          :key="index"
          v-for="(cluster, index) in cards"
        >
          <template v-if="cluster?.length > 1">
            <ux-atoms-typo
              :text="$t('ux.molecules.mapRestaurantList.label', { count: cluster.length })"
              as="p"
              class="Map-restaurant-list__cluster-title"
              variant="text-heading-02"
            />
            <ul>
              <li :class="['Map-restaurant-list__item']" :key="card.id" v-for="card in cluster">
                <ux-molecules-card-restaurant
                  v-bind="card"
                  :variant="VariantType.Map"
                  @card-restaurant::interact="cardEvent"
                  @mouseover="updateId(cluster[0].id)"
                />
              </li>
            </ul>
          </template>
          <template v-else-if="cluster?.length">
            <ux-molecules-card-restaurant
              v-bind="cluster[0]"
              :class="['Map-restaurant-list__item', { 'Map-restaurant-list__item--active': currentRestaurantId === cluster[0].id }]"
              :variant="VariantType.Map"
              @card-restaurant::interact="cardEvent"
              @mouseover="updateId(cluster[0].id)"
            />
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { VariantType, type cardType } from '~/components/ux/molecules/CardRestaurant/types';
import { gtmEvent } from '~/helpers/gtm';
import { useScrollToContainer } from '~/helpers/scrollToContainer';

export interface MapRestaurantListProps {
  cards: cardType[][] | null;
  label?: null | string;
}

const props = defineProps<MapRestaurantListProps>();

const store = useMapRestaurantsStore();

const updateId = (cardId: string) => {
  store.updateSelectedClusterId(cardId, '');
};

const currentRestaurant = computed(() => {
  return store.selectedCluster;
});

const currentRestaurantId = computed(() => {
  return currentRestaurant.value.id || props.cards?.[0][0].id;
});

const cardEvent = (cardTitle: string) => {
  gtmEvent('bloc_interact', {
    bloc_interaction: `select - ${cardTitle}`,
    bloc_name: 'restaurant list',
    pagename: 'restaurantsandbars::results::map'
  });
};

watch(
  () => currentRestaurant.value,
  (currentRestaurant) => {
    if (currentRestaurant.action === 'scroll') {
      const scrollIndex = props.cards?.findIndex((cluster) => {
        return cluster.find((restaurant) => restaurant.id === currentRestaurant.id);
      });
      useScrollToContainer(`Map-restaurant-list__item-container-${scrollIndex}`, 'Map-restaurant-list__container', 'start', 10);
    }
  },
  { deep: true }
);
</script>
<style lang="scss" scoped>
@use 'MapRestaurantList.scss';
</style>
